"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rhino = void 0;
const FetchHttpRequest_1 = require("./core/FetchHttpRequest");
const AgeverificationService_1 = require("./services/AgeverificationService");
const AgreementService_1 = require("./services/AgreementService");
const ChathostService_1 = require("./services/ChathostService");
const ClassifiersService_1 = require("./services/ClassifiersService");
const EventsService_1 = require("./services/EventsService");
const ImagesService_1 = require("./services/ImagesService");
const KycService_1 = require("./services/KycService");
const LogonService_1 = require("./services/LogonService");
const PromoService_1 = require("./services/PromoService");
const RegwizardService_1 = require("./services/RegwizardService");
const RevenueDetailsService_1 = require("./services/RevenueDetailsService");
const SessionService_1 = require("./services/SessionService");
const StudioService_1 = require("./services/StudioService");
class Rhino {
    ageverification;
    agreement;
    chathost;
    classifiers;
    events;
    images;
    kyc;
    logon;
    promo;
    regwizard;
    revenueDetails;
    session;
    studio;
    request;
    constructor(config, HttpRequest = FetchHttpRequest_1.FetchHttpRequest) {
        this.request = new HttpRequest({
            BASE: config?.BASE ?? '',
            VERSION: config?.VERSION ?? '0.6.49',
            WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
            CREDENTIALS: config?.CREDENTIALS ?? 'include',
            TOKEN: config?.TOKEN,
            USERNAME: config?.USERNAME,
            PASSWORD: config?.PASSWORD,
            HEADERS: config?.HEADERS,
            ENCODE_PATH: config?.ENCODE_PATH,
        });
        this.ageverification = new AgeverificationService_1.AgeverificationService(this.request);
        this.agreement = new AgreementService_1.AgreementService(this.request);
        this.chathost = new ChathostService_1.ChathostService(this.request);
        this.classifiers = new ClassifiersService_1.ClassifiersService(this.request);
        this.events = new EventsService_1.EventsService(this.request);
        this.images = new ImagesService_1.ImagesService(this.request);
        this.kyc = new KycService_1.KycService(this.request);
        this.logon = new LogonService_1.LogonService(this.request);
        this.promo = new PromoService_1.PromoService(this.request);
        this.regwizard = new RegwizardService_1.RegwizardService(this.request);
        this.revenueDetails = new RevenueDetailsService_1.RevenueDetailsService(this.request);
        this.session = new SessionService_1.SessionService(this.request);
        this.studio = new StudioService_1.StudioService(this.request);
    }
}
exports.Rhino = Rhino;
